export const getCurrentValues = ({ values }) => {
  const newQuery = {};

  // TODO to adapt this code with the others filters
  if (values.query.avatar === false) {
    newQuery.avatar = '';
  }
  if (values.query.deceased === false) {
    newQuery.deceased = '';
  }

  const filters = { query: { ...values.query, ...newQuery } };

  return filters;
};
